var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.841797,
    width: 62,
    height: 59.3768,
    rx: 10,
    fill: "#080808"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8337 30.5307V46.1044H18.0837C16.7049 46.1044 15.5837 45.0567 15.5837 43.7683V30.4521C15.8528 30.5035 16.1316 30.5307 16.417 30.5307H26.8337ZM28.5003 30.5307V46.1044H33.5003V30.5307H28.5003ZM45.5836 30.5307H35.167V46.1044H43.917C45.2957 46.1044 46.417 45.0567 46.417 43.7683V30.4521C46.1478 30.5035 45.8691 30.5307 45.5836 30.5307ZM48.0836 23.5226V26.6373C48.0836 27.9256 46.9624 28.9733 45.5836 28.9733H16.417C15.0382 28.9733 13.917 27.9256 13.917 26.6373V23.5226C13.917 22.2342 15.0382 21.1865 16.417 21.1865H24.3416C23.8162 20.5347 23.5003 19.7272 23.5003 18.8505C23.5003 16.7036 25.3695 14.957 27.667 14.957C29.0307 14.957 30.2399 15.5753 31.0003 16.5245C31.7612 15.5753 32.9699 14.957 34.3337 14.957C36.6312 14.957 38.5003 16.7036 38.5003 18.8505C38.5003 19.7272 38.1845 20.5347 37.6591 21.1865H45.5836C46.9624 21.1865 48.0836 22.2342 48.0836 23.5226ZM31.8337 18.8505V21.1865H34.3337C35.7124 21.1865 36.8337 20.1388 36.8337 18.8505C36.8337 17.5621 35.7124 16.5144 34.3337 16.5144C32.9549 16.5144 31.8337 17.5621 31.8337 18.8505ZM27.667 21.1865H30.167V18.8505C30.167 17.5621 29.0457 16.5144 27.667 16.5144C26.2882 16.5144 25.167 17.5621 25.167 18.8505C25.167 20.1388 26.2882 21.1865 27.667 21.1865Z",
    fill: "#00E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon-6.f077142914c59048050d9af02ab93ec7.svg";
export { ForwardRef as ReactComponent };